import { IError } from '~src/httpClient/serverApi/types/IError';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ISiteAdminSettings, ISiteSubscriptionSettings } from '../../../types/ISiteSettingsForSiteAdmin';

export interface IUpdateSiteSettingsForSiteAdminParams {
  id: string;
  siteAdminSettings: ISiteAdminSettings;
  subscriptionSettings?: ISiteSubscriptionSettings;
}

export interface IUpdateSiteSettingsForSiteAdminResult {
  errors?: IError[];
}

export class UpdateSiteSettingsForSiteAdminRequest extends Request<IUpdateSiteSettingsForSiteAdminParams, IUpdateSiteSettingsForSiteAdminResult> {
  constructor(params: IUpdateSiteSettingsForSiteAdminParams) {
    super('updateSiteSettingsForSiteAdmin', params);
  }
}
